import { render, staticRenderFns } from "./TemplateThree.vue?vue&type=template&id=15e350d0&"
import script from "./TemplateThree.vue?vue&type=script&lang=js&"
export * from "./TemplateThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports